require('./brokerTodaysMainStocks.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');

// @helpers
const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const {
    BROKER_TODAYS_MAIN_STOCKS_DEFAULT_TAB,
    BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS,
    BROKER_TODAYS_MAIN_STOCKS_MAX_COLUMN_WIDTH_PG_STOCKS_LANDING,
    MYPROFILE_BROKER_EXPLORE_STOCKS_URL,
    BROKER_MAIN_STOCKS_TAB_RISERS,
    BROKER_MAIN_STOCKS_TAB_FALLERS,
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
    DATE_FORMAT_DAY_MONTH_SHORT,
    BROKER_TYPE_STOCKS_NEW_DECIMALS
} = require('constants/index');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const StockExchangeIndexVariationSplitted = require('components/broker/commons/stockExchange/StockExchangeIndexVariationSplitted');
const { EmptyState } = require('commonsComponents/emptyState');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ helpers
const DateHelper = require('utilities/dateHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

class BrokerTodaysMainStocks extends React.Component {

    constructor(props) {
        super(props);

        this.handleSeeMoreHighestStocksClick = this.handleSeeMoreHighestStocksClick.bind(this);
        this.handleSeeMoreLowestStocksClick = this.handleSeeMoreLowestStocksClick.bind(this);
        this.handleStockMarketChange = this.handleStockMarketChange.bind(this);
        this.getMarketOptions = this.getMarketOptions.bind(this);
    }

    componentDidUpdate(prevProps) {
        // If we are setting first value after updating from service
        if (prevProps.immBrokerTodaysMainStocks.get('selectedMarket') === '' && this.props.immBrokerTodaysMainStocks.get('selectedMarket') !== '') {
            this.handleStockMarketChange({  // TODO: improve method insteas of simuluating an event
                value: this.props.immBrokerTodaysMainStocks.get('selectedMarket')
            })
        }
    }

    getMarketOptions() {
        const { immBrokerExchangeIndexes } = this.props;
        return immBrokerExchangeIndexes.get('indexesPlayers').toJS().map((exchangeIndex, index) => {
            return {
                index,
                value: exchangeIndex.spcSymbol,
                label: exchangeIndex.name
            };
        });
    }

    buildEmptyState() {
        const primaryText = formatText('broker-todaysMainStocksEmptyState');
        const secondaryText = formatText('broker-todaysMainStocksEmptyStateSecondary')
        const linkText = formatText('broker-mainStocksGoToSearch')
        return (
            <EmptyState
                secondaryText={secondaryText}
                primaryText={primaryText}
                linkText={linkText}
                linkURL={MYPROFILE_BROKER_EXPLORE_STOCKS_URL}
                iconType="nointernet-wealth" />
        );
    }

    buildSeeMoreButton(isRise) {
        const { immBrokerTodaysMainStocks } = this.props;
        const selectedMarket = immBrokerTodaysMainStocks.get('selectedMarket');
        const todaysMainStocksLink = `/myprofile/broker/mainStocks/${selectedMarket}`;
        const handleOnClick = isRise ? this.handleSeeMoreHighestStocksClick : this.handleSeeMoreLowestStocksClick;

        let button;

        if (!!selectedMarket && immBrokerTodaysMainStocks.get('stocksByMarket').get(selectedMarket)) {
            const stocksByMarket = immBrokerTodaysMainStocks.get('stocksByMarket').get(selectedMarket).get('byPercentage');
            const targetStocks = isRise ? stocksByMarket.get('risers') : stocksByMarket.get('fallers');
            let tableContent = targetStocks.slice(0, BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS);

            if (!tableContent.isEmpty()) {
                button = (
                    <section className="broker-todays-main-stocks__link-box" onClick={handleOnClick}>
                        <OKLink modifier="widget" to={todaysMainStocksLink}>
                            <FormattedText value="broker-todaysMainStocksSeeMoreHighestStocksLinkLabel" />
                        </OKLink>
                    </section>
                );
            }
        }

        return button;
    }

    buildTable(showRisers) {

        const { immBrokerTodaysMainStocks } = this.props;
        let stocksTable = <LoadingSection />
        const selectedMarket = immBrokerTodaysMainStocks.get('selectedMarket');

        if (!!selectedMarket && immBrokerTodaysMainStocks.get('stocksByMarket').get(selectedMarket)) {
            const stocksByMarket = immBrokerTodaysMainStocks.get('stocksByMarket').get(selectedMarket).get('byPercentage');
            const targetStocks = showRisers ? stocksByMarket.get('risers') : stocksByMarket.get('fallers');
            let tableContent = targetStocks.slice(0, BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS);
            let tableRows;

            const thereAreNoVariations = tableContent.filter(v => v.get('netChangePrice') !== 0).isEmpty();
            if (thereAreNoVariations) {
                const emptyState = this.buildEmptyState();
                return (
                    emptyState
                );
            } else {
                tableRows = tableContent.map((entry, index) => {
                    const url = `/myprofile/broker/stocksBuy/${entry.get('instrumentId')}/${entry.get('miccode')}`;

                    const updateDate = moment(entry.get('tradeDate'), DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);
                    const quoteDateIsToday = moment().isSame(updateDate, 'day');
                    const formattedDate = quoteDateIsToday ? formatText('common-today') : DateHelper.buildFormattedDate(updateDate, DATE_FORMAT_DAY_MONTH_SHORT);

                    const updateTime = entry.get('tradeTime') || '';
                    const updateTimeElement = <span>{updateTime}</span>

                    return (
                        <OKTableRow key={index}>
                            <OKTableCell
                                className="broker-todays-main-stocks__stocks-table-column--first"
                                maxWidth={BROKER_TODAYS_MAIN_STOCKS_MAX_COLUMN_WIDTH_PG_STOCKS_LANDING}
                                truncate={true}
                                width="240"
                            >
                                <OKLink
                                    onClick={() => taggingEventHandled(this.props.pageName, 'todayProtagonistsProductLink', entry.get('instrument'))}
                                    to={`/myprofile/broker/productFile/${entry.get('instrumentId')}/${entry.get('miccode')}`}>
                                    {entry.get('instrument')}
                                </OKLink>
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                width="85"
                            >
                                <span className="broker-todays-main-stocks__last-value">
                                    {formatAmount(entry.get('last'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                                </span>
                            </OKTableCell>
                            <OKTableCell
                                className="broker-todays-main-stocks__stocks-table-column broker-todays-main-stocks__stocks-table-column--variation"
                                alignment="right"
                                width="100"
                            >
                                <StockExchangeIndexVariationSplitted
                                    variationPts={formatAmount(entry.get('netChangePrice'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                                    variationPerc={formatAmount(entry.get('netChangePercentage'))}
                                    upOrDown={entry.get('netChangePrice') > 0 ? 'up' : 'down'}
                                />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                width="80"
                            >
                                {formatAmount(entry.get('high'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                width="70"
                            >
                                {formatAmount(entry.get('low'), getLanguage(), BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                width="80"
                            >
                                <OKTooltip
                                    target={updateTimeElement}
                                    content={formattedDate}
                                    offset={[0,-10]}
                                    type="custom"
                                />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                className="broker-todays-main-stocks__stocks-table-column broker-todays-main-stocks__stocks-table-column--action"
                                maxWidth="50"
                                width="80"
                            >
                                <div className="broker-todays-main-stocks__buy-button">
                                    <OKButton modifier="secondary" size="compact" onClick={() => this.props.onHandleBuyClick(url, entry.get('instrument'))}>
                                        <div className="broker-todays-main-stocks__buy-button-label">
                                            <FormattedText value="broker-todaysMainStocksBuyButtonLabel" format="uppercase" />
                                        </div>
                                    </OKButton>
                                </div>
                            </OKTableCell>
                        </OKTableRow>
                    );
                });
            }

            const iconInfo = (
                <OKTooltip
                    target={<i className="icon icon-tooltip broker-todays-main-stocks__time-info-icon"/>}
                    content="broker-todaysMainStocksTimeTooltip"
                    offset={[0,-10]}
                />
            );

            stocksTable = (
                <OKTable className="broker-todays-main-stocks__stocks-table">
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="broker-todays-main-stocks__stocks-table-first-column"
                            >
                                <FormattedText value="broker-todaysMainStocksStockNameColumnHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="85"
                            >
                                <FormattedText value="broker-todaysMainStocksLastValueColumnHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="120"
                            >
                                <FormattedText value="broker-todaysMainStocksVariationColumnHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="80"
                            >
                                <FormattedText value="broker-todaysMainStocksMaxValueColumnHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="70"
                            >
                                <FormattedText value="broker-todaysMainStocksMinValueColumnHeader" />
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                width="80"
                            >
                                <FormattedText value="broker-todaysMainStocksTimeColumnHeader" />
                                {iconInfo}
                            </OKTableCell>
                            <OKTableCell
                                alignment="right"
                                asHeader={true}
                                className="broker-todays-main-stocks__stocks-table-column broker-todays-main-stocks__stocks-table-column--action"
                                maxWidth="50"
                                width="80"
                            >
                                <FormattedText value="broker-todaysMainStocksActionsColumnHeader" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
            );
        }

        return stocksTable;
    }

    handleSeeMoreHighestStocksClick() {
        this.props.setShowMoreSelectedTab(BROKER_MAIN_STOCKS_TAB_RISERS);
        taggingEventHandled(this.props.pageName, 'todayProtagonistsSeeMore')

    }

    handleSeeMoreLowestStocksClick() {
        this.props.setShowMoreSelectedTab(BROKER_MAIN_STOCKS_TAB_FALLERS);
        taggingEventHandled(this.props.pageName, 'todayProtagonistsSeeMore')

    }

    handleStockMarketChange(event) {
        const name = event.value;
        const itemIndex = event.label;
        const { immBrokerExchangeIndexes, getRisersAndFallers, resetStocksMarket } = this.props;
        const selectedItem = immBrokerExchangeIndexes.get('indexesPlayers').find(item => item.get('spcSymbol') === name);
        if (selectedItem) {
            resetStocksMarket();
            getRisersAndFallers({
                exchangeId: selectedItem.get('exchangeId'),
                spcSymbol: selectedItem.get('spcSymbol'),
                market: name,
                resultsAmount: BROKER_TODAYS_MAIN_STOCKS_MAX_ROWS,
                byVolume: { risers: false, fallers: false },
                byPercentage: { risers: true, fallers: true }
            });
        }
       itemIndex !== undefined && taggingEventHandled(this.props.pageName, 'todayProtagonistsInputSelect', itemIndex)
    }

    render() {
        const { immBrokerExchangeIndexes, immBrokerTodaysMainStocks } = this.props;
        const selectedMarket = immBrokerTodaysMainStocks.get('selectedMarket');
        const marketOptions = this.getMarketOptions();

        const stockMarketSelect = (
            <OKSelect
                className="broker-todays-main-stocks__market-dropdown"
                name="stockMarket"
                onChange={(event) => this.handleStockMarketChange(event)}
                options={marketOptions}
                value={selectedMarket}
                searchable={false}
            />
        );

        const seeMoreRiseButton = this.buildSeeMoreButton(true);
        const seeMoreLowButton = this.buildSeeMoreButton(false);
        const riseContent = immBrokerTodaysMainStocks.get('error') || !immBrokerExchangeIndexes.get('indexesPlayers').size ? this.buildEmptyState() : this.buildTable(true);
        const lowContent = immBrokerTodaysMainStocks.get('error') || !immBrokerExchangeIndexes.get('indexesPlayers').size? this.buildEmptyState() : this.buildTable(false);
        const brokerHighestStocks = (
            <div>
                <section>
                    <div>
                        {stockMarketSelect}
                        <div className="broker-todays-main-stocks__after-dropdown-label">
                            <FormattedText value="broker-todaysMainStocksHighestStocksText" />
                        </div>
                    </div>
                    <div className="broker-todays-main-stocks__stocks-table-wrapper">
                        {riseContent}
                    </div>
                </section>
                {seeMoreRiseButton}
            </div>
        );
        const brokerLowestStocks = (
            <div>
                <section>
                    <div className="broker-todays-main-stocks__dropdown-and-label">
                        {stockMarketSelect}
                        <div className="broker-todays-main-stocks__after-dropdown-label">
                            <FormattedText value="broker-todaysMainStocksLowestStocksText" />
                        </div>
                    </div>
                    <div className="broker-todays-main-stocks__stocks-table-wrapper">
                        {lowContent}
                    </div>
                </section>
                {seeMoreLowButton}
            </div>
        );


        const iconInfo = (
            <OKTooltip
                target={<i onMouseEnter={() => taggingEventHandled(this.props.pageName, 'todayProtagonistsTooltip')}
                    className="icon icon-tooltip broker-market-trends__tooltip" />}
                content="todayMainStock-todayMainStockTooltip"
                placement="right"
                offset={[10, 8]}
            />
        );

        const tabLabels = [
            <div
                onClick={() => taggingEventHandled(this.props.pageName, 'todayProtagonistsSelector', 'better')}>
                {formatText('broker-todaysMainStocksHighestStocksTabName')}
            </div>,
            <div
                onClick={() => taggingEventHandled(this.props.pageName, 'todayProtagonistsSelector', 'worse')}>
                {formatText('broker-todaysMainStocksLowestStocksTabName')}
            </div>
        ]

        return (
            <div>
                <TabbedContentBox
                    id="brokerTodaysMainStocks"
                    customClassName="broker-todays-main-stocks"
                    tabComponents={[brokerHighestStocks, brokerLowestStocks]}
                    tabLabels={tabLabels}
                    title={formatText('broker-todaysMainStocksTitle')}
                    defaultTabIndex={BROKER_TODAYS_MAIN_STOCKS_DEFAULT_TAB}
                    extraContent={iconInfo}
                    tabsAsPills={true}
                />
            </div>
        );

    }

}

BrokerTodaysMainStocks.propTypes = {
    immBrokerTodaysMainStocks: PropTypes.object.isRequired,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    getRisersAndFallers: PropTypes.func.isRequired,
    setStockMarket: PropTypes.func.isRequired,
    resetStocksMarket: PropTypes.func.isRequired,
    onHandleBuyClick: PropTypes.func,
    setShowMoreSelectedTab: PropTypes.func.isRequired,
    pageName: PropTypes.string
}

module.exports.constructor = BrokerTodaysMainStocks;
module.exports.BrokerTodaysMainStocks = connect(
    state => ({
        immBrokerTodaysMainStocks: state.brokerTodaysMainStocks,
        immBrokerExchangeIndexes: state.brokerExchangeIndexes
    }), {
        getRisersAndFallers: brokerTodaysMainStocksActions.getRisersAndFallers,
        setStockMarket: brokerTodaysMainStocksActions.setStockMarket,
        resetStocksMarket: brokerTodaysMainStocksActions.resetStocksMarket,
        setShowMoreSelectedTab: brokerTodaysMainStocksActions.setShowMoreSelectedTab
    })(BrokerTodaysMainStocks);
